import React from 'react';
import PropTypes from 'prop-types';
import { FieldTable } from '../../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import { SitePlanning } from 'generated/graphql';
import {SitePlanningStageSelect} from "../../../components/MaterialSelects/SitePlanningStageSelect";
import {SitePlanningOutcomeSelect} from "../../../components/MaterialSelects/SitePlanningOutcomeSelect";
import {TextField} from "@mui/material";


const columns:FieldTableColumnProps<SitePlanning>[] = [
    {
        accessor:'expand',
        dataType: 'expander'
    },    {
        header:'Stage',
        accessor:'planningStage',
        sort:'planningStage.label',
        dataType:'select',
        options: {
            label:'label',
            renderEditor: ({ field}) =>
        <SitePlanningStageSelect {...field} autoFocus={true} error={field.error} allowBlank={true} />,
        }
    },{
        header: 'Date',
        accessor: 'planning_date',
        dataType:'date'
    },{
        header: 'Outcome',
        accessor: 'planningOutcome',
        dataType:'select',
        options: {
            label:'label',
            renderEditor: ({field}) => <SitePlanningOutcomeSelect allowBlank={true} {...field} />
        }
    },{
        header: 'Date',
        accessor: 'outcome_date',
        dataType:'date',
    },{
        header: 'Amount',
        accessor: 'amount',
        dataType:'currency',
    }
];
function newRow() {
    return ({});
}

const PlanningPane = ({values,setValue,readOnly})=> {
    const doChange = (evt) => {
        setValue(evt.target.name, evt.target.value);
    }
    return (
        <FieldTable columns={columns}
         name="sitePlannings" 
         className="site-planning"
        values={values}
        setValue={setValue}
        readOnly={readOnly}
        newRow={newRow}
        newRowLabel="Add Planning entry"
        >{({name, row}) => {
            return <div>
                <TextField readOnly={readOnly} multiline={true} name={name + '.notes'} onChange={doChange} fullWidth={true} value={row.notes} placeholder="Planning Notes" />
                <TextField readOnly={readOnly} multiline={true} name={name + '.outcome_notes'} onChange={doChange} fullWidth={true} value={row.outcome_notes} placeholder="Outcome Notes" />
            </div>;
        }}</FieldTable>
        );
}

PlanningPane.propTypes = {
    health_and_safety:PropTypes.array
};

export default PlanningPane;

